import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import * as FavoritesSelectors from './favorites.selectors';
import * as actions from './favorites.actions';
import { FavoriteLocation, FavoritePreference, FavoriteStop } from '../../favorites';
import { FavoriteSchedule } from '../favorites.model';

@Injectable()
export class FavoritesFacade {
    favoriteStops$ = this.store.pipe(select(FavoritesSelectors.favoriteStops));
    favoriteStopsLoading$ = this.store.pipe(select(FavoritesSelectors.favoriteStopsLoading));
    favoriteLocations$ = this.store.pipe(select(FavoritesSelectors.favoriteLocations));
    favoriteTickets$ = this.store.pipe(select(FavoritesSelectors.favoriteTickets));
    favoriteTicketsLoading$ = this.store.pipe(select(FavoritesSelectors.favoriteTicketsLoading));
    favoritePreference$ = this.store.pipe(select(FavoritesSelectors.favoritePreference));
    favoriteSchedules$ = this.store.pipe(select(FavoritesSelectors.favoriteSchedules));

    constructor(private store: Store) {}

    getFavoriteStops(): void {
        this.store.dispatch(actions.getFavoriteStops());
    }

    addFavoriteStop(stop: FavoriteStop): void {
        this.store.dispatch(actions.addFavoriteStop({ stop }));
    }

    addFavoriteStopFromLocalstorage(stopIds: string[]): void {
        this.store.dispatch(actions.addFavoriteStopsFromLocalstorage({ favoriteStopIds: stopIds }));
    }

    updateFavoriteStop(stopId: string, alias: string): void {
        this.store.dispatch(actions.updateFavoriteStop({ stopId, alias }));
    }

    deleteFavoriteStop(stopId: string): void {
        this.store.dispatch(actions.deleteFavoriteStop({ stopId }));
    }

    deleteFavoriteStops(stopIds: string[]): void {
        return this.store.dispatch(actions.deleteFavoriteStops({ stopIds }));
    }

    getFavoriteLocations(): void {
        this.store.dispatch(actions.getFavoriteLocations());
    }

    addFavoriteLocation(favoriteLocation: FavoriteLocation): void {
        this.store.dispatch(actions.addFavoriteLocation(favoriteLocation));
    }

    addFavoriteLocationFromLocalstorage(locations: FavoriteLocation[]): void {
        this.store.dispatch(actions.addFavoriteLocationsFromLocalstorage({ favoriteLocations: locations }));
    }

    updateFavoriteLocation(favoriteLocation): void {
        this.store.dispatch(actions.updateFavoriteLocation(favoriteLocation));
    }

    deleteFavoriteLocation(favoriteLocation: FavoriteLocation): void {
        this.store.dispatch(actions.deleteFavoriteLocation(favoriteLocation));
    }

    deleteFavoriteLocations(locations: FavoriteLocation[]): void {
        return this.store.dispatch(actions.deleteFavoriteLocations({ favoriteLocations: locations }));
    }

    getFavoriteTickets(): void {
        this.store.dispatch(actions.getFavoriteTickets());
    }

    addFavoriteTicket(data: {
        docNum: string;
        categoryCode: string;
        productId: number;
        startDateStr?: string;
        endDateStr?: string;
        includeReturnedTickets?: boolean;
        includeCancelledTickets?: boolean;
        channels?: string[];
    }): void {
        this.store.dispatch(actions.addFavoriteTicket(data));
    }

    deleteFavoriteTicket(productId: number | string): void {
        this.store.dispatch(actions.deleteFavoriteTicket({ productId }));
    }

    getFavoritePreference(): void {
        this.store.dispatch(actions.getFavoritePreference());
    }

    addFavoritePreference(data: FavoritePreference): void {
        this.store.dispatch(actions.addFavoritePreference(data));
    }

    deleteFavoritePreference(): void {
        this.store.dispatch(actions.deleteFavoritePreference());
    }

    getFavoriteSchedules(): void {
        this.store.dispatch(actions.getFavoriteSchedules());
    }

    addFavoriteSchedule(favoriteSchedule: FavoriteSchedule): void {
        this.store.dispatch(actions.addFavoriteSchedule({ favoriteSchedule }));
    }

    deleteFavoriteSchedules(favoriteSchedules: FavoriteSchedule[]): void {
        this.store.dispatch(actions.deleteFavoriteSchedules({ favoriteSchedules }));
    }

    addFavoriteSchedulesFromLocalstorage(): void {
        this.store.dispatch(actions.addFavoriteSchedulesFromLocalstorage());
    }
}
